const parser = new DOMParser()

interface XmlAttributes {
    [key: string]: string
}

export function htmlToElement<T extends Element = HTMLElement>(html: string): T {
    return parser.parseFromString(html, "text/html").body.firstElementChild as T
}

export function xmlToElement<T extends Element = SVGElement>(
    xml: string,
    attributes: XmlAttributes = {},
    namespace = "http://www.w3.org/2000/svg",
): T {
    const xmlElement = document.createElementNS(namespace, xml) as T

    for (const attributeName in attributes) {
        xmlElement.setAttribute(attributeName, attributes[attributeName])
    }

    return xmlElement
}
